import React from 'react';
import { Check, Zap } from 'lucide-react';
import { ADDON_CATALOG, sumAddonsCents, formatBRL } from '../../constants/addonCatalog';

const accentMap = {
  amber: {
    selectedBorder: 'border-amber-400',
    selectedBg: 'bg-amber-50',
    iconWrap: 'bg-amber-100 text-amber-600',
    badge: 'text-amber-700',
    price: 'text-amber-600',
  },
  blue: {
    selectedBorder: 'border-blue-400',
    selectedBg: 'bg-blue-50',
    iconWrap: 'bg-blue-100 text-blue-600',
    badge: 'text-blue-700',
    price: 'text-blue-600',
  },
};

const AddonSelector = ({ selected = [], onChange }) => {
  // Apenas itens marcados como showInRegistration aparecem aqui (cadastro).
  // E-books "loja" (vendidos so dentro de /services) ficam invisiveis aqui.
  const visibleAddons = ADDON_CATALOG.filter((a) => a.showInRegistration !== false);

  const toggle = (id) => {
    const isSelected = selected.includes(id);
    const next = isSelected ? selected.filter((x) => x !== id) : [...selected, id];
    onChange?.(next);
  };

  const totalCents = sumAddonsCents(selected);

  return (
    <div className="mb-6">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-700">
          E-books e serviços que impulsionam seu negócio
        </h3>
        {totalCents > 0 && (
          <span className="text-xs font-semibold text-gray-700 bg-gray-100 rounded-full px-3 py-1">
            +{formatBRL(totalCents)} hoje
          </span>
        )}
      </div>

      <div className="space-y-3">
        {visibleAddons.map((addon) => {
          const Icon = addon.icon;
          const isSelected = selected.includes(addon.id);
          const accent = accentMap[addon.accent] || accentMap.amber;
          return (
            <button
              key={addon.id}
              type="button"
              onClick={() => toggle(addon.id)}
              className={`w-full text-left p-4 rounded-2xl border-2 transition-all ${
                isSelected
                  ? `${accent.selectedBorder} ${accent.selectedBg} shadow-sm`
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`p-2.5 rounded-xl flex-shrink-0 ${accent.iconWrap}`}>
                  <Icon className="w-5 h-5" />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                      <p className="font-semibold text-gray-900 text-sm leading-tight">
                        {addon.name}
                      </p>
                      <p className="text-xs text-gray-500 mt-0.5">{addon.tagline}</p>
                    </div>
                    <span className={`font-bold text-sm whitespace-nowrap ${accent.price}`}>
                      {addon.priceFormatted}
                    </span>
                  </div>

                  <p className="text-xs text-gray-500 mt-2 line-clamp-2">
                    {addon.description}
                  </p>

                  <div className="mt-2 flex items-center gap-1.5">
                    <Zap className={`w-3 h-3 ${accent.badge}`} />
                    <span className={`text-xs font-medium ${accent.badge}`}>
                      Acesso imediato
                    </span>
                  </div>
                </div>

                <div
                  className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${
                    isSelected
                      ? `${accent.selectedBorder} ${accent.selectedBg.replace('bg-', 'bg-')}`
                      : 'border-gray-300 bg-white'
                  }`}
                >
                  {isSelected && <Check className={`w-4 h-4 ${accent.price}`} />}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AddonSelector;
